import React, { useEffect, useState } from "react";
import useStyles from "./ApproveDialog.css";
import translation from "../../../../i18n/i18.json";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormLabel,
  Grid,
  MenuItem,
  Paper,
  Select,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { AlertDialogState } from "../../../../reducers/components/AlertDialogReducer";
import { RootState } from "../../../../reducers/index";
import { ApprovalStatusData } from "../../../../models/Approval/ApprovalStatusData";
import AllActions from "../../../../actions";
import { UserLoginState } from "../../../../reducers/LoginReducer";
import { RoleUtil } from "../../../../utils/RoleUtil";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { ApprovalPointUtil } from "../../../../utils/ApprovalPointUtil";
import { ResponseObject } from "../../../../models/ResponseObject";
import {
  AppApprovalPoints,
  FieldsLengthConstants,
  InforDisplyaDuration,
  RequestStatus,
  ResponseObjectType,
  DropdownOptions_TemporaryApproval_NoOfDays
} from "../../../../constants/AppConstants";
import { FormError } from "../../../../models/FormValidation/FormError";
import { FormFieldMeta } from "../../../../models/FormValidation/FormFieldMeta";
import { FormUtil } from "../../../../utils/FormUtil";
import { FormValidateData } from "../../../../models/FormValidation/FormValidateData";
import { InstructionKey } from "../../../../models/InstructionKey";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { PaymentPurpose } from "../../../../models/PaymentPurpose";
import { VendorMasterData } from "../../../../services/VendorMasterData";
import { RequestService } from "../../../../services/RequestService";
import { VendorAmendService } from "../../../../services/VendorAmendService";
import { SortCode } from "../../../../models/SortCode";
import { TempApprovalNoOfDays } from "../../../../models/TempApprovalNoOfDays";
import { Style } from "@material-ui/icons";
import { CheckListItem } from "../../../../models/CheckListItem";
import { constants } from "buffer";

interface ApproveDialogProps {
  open: boolean;
  title: string;
  message: string;
  btnOnetext: string;
  btnTwotext: string;
  onApproveConfirm: any;
  onApproveCancel: any;
  handleClose: any;
  dataToApprove: ApprovalStatusData;
  setDataToApprove: any;
}

export default function ApproveDialog(props: ApproveDialogProps) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    open,
    title,
    message,
    btnOnetext,
    btnTwotext,
    onApproveConfirm,
    onApproveCancel,
    handleClose,
    dataToApprove,
    setDataToApprove
  } = props;
  const [isUrgent, setIsUrgent] = useState(false);
  const [isSendVendorConfirmation, setIsSendVendorConfirmation] = useState(false);
  const [isTempApproval, setIsTempApproval] = useState(dataToApprove?.isTemporaryApproval ? true : false);
  //const [isShowUrgent, setIsShowUrgent] = useState(false);
  const loginUserDetails = useSelector<RootState, UserLoginState>(
    (state) => state.loginDetails
  );
  const [formErrors, setFormErrors] = useState<FormError[]>([]);
  const [fistSubmitDone, setFistSubmitDone] = useState(false);

  const [instructionkeys, setInstructionkey] = useState(
    Array<InstructionKey>()
  );

  const [paymentpurposes, setPaymentpurposes] = useState(Array<PaymentPurpose>());
  const [checkListItems, setCheckListItems] = useState(Array<CheckListItem>());
  const [checkListItemsFiltered, setCheckListItemsFiltered] = useState(Array<CheckListItem>());
  const [selectedCheckListItemIds, setSelectedCheckListItemIds] = useState(Array<number>());
  const [sortkeys, setSortkeys] = useState(Array<SortCode>());
  const [tabSelectIndex, setTabSelectIndex] = React.useState<string>();
  const [noOfDays, setNoOfDays] = useState(Array<TempApprovalNoOfDays>());
  const [approverComment, setApproverComment] = useState("");

  const handleTabChange = (event: any, newValue: string) => {
    setTabSelectIndex(newValue);
    setFilteredCheckList(newValue, checkListItems, false);
  };

  useEffect(() => {
    if (RoleUtil.hasAuthVendorApprove(loginUserDetails)) {
      if (dataToApprove && ApprovalPointUtil.isUrgentAproveDisplay(dataToApprove.approvalLevelId)) {
        //setIsShowUrgent(true);
      }
    }

  },[]);

  useEffect(() => {
    setIsTempApproval(dataToApprove?.isTemporaryApproval ? true : false);
  },[dataToApprove]);

  const handleExit = () => {
    setIsUrgent(false);
    setIsSendVendorConfirmation(false);
    setFormErrors([]);
    setFistSubmitDone(false);
    setCheckListItemsFiltered([]);
    setIsTempApproval(false);
  };

  const prepareForRequest = () => {
    dispatch(AllActions.backDropActions.openBackDrop());
  };

  const compeleteRequest = (
    success: boolean,
    message?: string,
    duration?: number
  ) => {
    dispatch(AllActions.backDropActions.closeBackDrop());
    if (message) {
      let messageduration = duration ? duration : InforDisplyaDuration.common;
      if (success) {
        dispatch(
          AllActions.infoActions.openInforSuccess(message, messageduration!)
        );
      } else {
        dispatch(
          AllActions.infoActions.openInforError(message, messageduration!)
        );
      }
    }
  };

  const getApprovalPointCheckList = (approvalPointId: number) => {
    return checkListItems.filter(c => { return c.approvalLevelId == approvalPointId; });
  };

  const isCheckListComplete = () => {
    let checkItems = getApprovalPointCheckList(dataToApprove.approvalLevelId);
    let pendingChecks = checkItems.filter(c => c.priorityId == 1 && !c.isChecked);
    if (pendingChecks.length > 0) {
      dispatch(AllActions.infoActions.openInforError(translation.appropopup_vendor_request_pendingcheck, InforDisplyaDuration.approvalStatus));
      return false;
    }
    return true;
  };

  const validateData = () => {
    //make purposeCode set blank if not matching with defined list
    let purposeCode = paymentpurposes.find((r) => {
      return r.code === dataToApprove.vcExtendedInputs.purposeCode;
    });
    if (!purposeCode) {
      dataToApprove.vcExtendedInputs.purposeCode = "";
    }
    if (ApprovalPointUtil.isSAPCreateOrAmendOrExtend(dataToApprove.approvalLevelId)) {
      const validateSAPCreateFieldsData: Array<FormFieldMeta> = [
        {
          fieldName: "accountingClarkEmail",
          isRequired: true,
          reuiredMsg: "Accounting Email is required",
          formatFunc: FormUtil.isValidEmail.bind(
            dataToApprove.vcExtendedInputs.accountingClarkEmail
          ),
          formatMsg: translation.vendor_crete_form1_emailfomat_error,
        },
        {
          fieldName: "accountingClark",
          isRequired: true,
          reuiredMsg: "Accounting Clark is required",
        },
        // {
        //   fieldName: "instructionKey",
        //   isRequired: false,
        //   reuiredMsg: "Instruction key is required",
        // },
      ];

      let formValidateData: FormValidateData = FormUtil.validateFields(
        validateSAPCreateFieldsData,
        dataToApprove.vcExtendedInputs
      );

      setFormErrors(formValidateData.errorsList);
      return formValidateData.isValid;
    }
    if (ApprovalPointUtil.isSBUSCHeadOrGSSCLead(dataToApprove.approvalLevelId)) {
      if (isTempApproval && (dataToApprove.temporaryApprovalNoOfDays == "" || dataToApprove.temporaryApprovalNoOfDays == "None")) {
        dispatch(AllActions.infoActions.openInforError(translation.appropopup_vendor_request_sbuapproval, InforDisplyaDuration.common));
        return false;
      }
    }
    return true;
  };

  useEffect(() => {
    if (fistSubmitDone) {
      validateData();
    }
  }, [dataToApprove]);

  const handleConfirm = () => {
    let isCheckListAvailable = ApprovalPointUtil.isCheckListApplicable(dataToApprove.vendorTypeCode, dataToApprove.approvalLevelId);
    let isCheckListValid = !isCheckListAvailable || isCheckListComplete();
    setFistSubmitDone(true);

    if (validateData() && isCheckListValid) {
      dataToApprove.reasonForRejection = approverComment;
      //set check list data
      if (isCheckListAvailable) {
        dataToApprove.checkListItems = getApprovalPointCheckList(dataToApprove.approvalLevelId);
      }
      dataToApprove.isSendVerificationNotification = isSendVendorConfirmation;
      dataToApprove.isTemporaryApproval = isTempApproval;
      updateApprovalStatus();
    }
    // else {
    //   updateApprovalStatus();
    // }
  };

  const updateApprovalStatus = () => {
    prepareForRequest();
    let sucuceesmsg = "";

    switch (dataToApprove.approvalLevelId) {
      case AppApprovalPoints.VCCreate: {
        sucuceesmsg = translation.appropopup_vendor_request_vendorcreate;
        break;
      }
      case AppApprovalPoints.AmendCreate: {
        sucuceesmsg = translation.appropopup_vendor_request_vendoreamend;
        break;
      }
      case AppApprovalPoints.VEExtendVendor: {
        sucuceesmsg = translation.appropopup_vendor_request_vendorextend;
        break;
      }
      default:
        sucuceesmsg = "";
        break;
    }

    RequestService.SetApprovalStatus(
      dataToApprove,
      function (approvalRespone: ResponseObject) {
        if (
          approvalRespone &&
          (approvalRespone.resposeObjectType === ResponseObjectType.SAPError ||
            approvalRespone.resposeObjectType === ResponseObjectType.Error)
        ) {
          compeleteRequest(false, approvalRespone.message);
        } else if (
          approvalRespone &&
          approvalRespone.resposeObjectType === ResponseObjectType.SAPSuccess
        ) {
          compeleteRequest(
            true,
            `${approvalRespone.result} ${sucuceesmsg}`,
            InforDisplyaDuration.approvalStatus
          );
          //onApproveConfirm(approvalRespone.result);
          onApproveConfirm(-1);
        } else {
          compeleteRequest(
            true,
            translation.appropopup_vendor_request_aprovesucess
          );
          onApproveConfirm(approvalRespone.result);
        }
      },
      function (error: Error) {
        console.log(error);
        compeleteRequest(
          false,
          translation.appropopup_vendor_request_approve_err
        );
      }
    );
  };

  const handleChange = (input: string) => (e: any) => {
    //setDataToApprove({ ...dataToApprove, [input]: e.target.value });
    setDataToApprove({
      ...dataToApprove,
      vcExtendedInputs: {
        ...dataToApprove.vcExtendedInputs,
        [input]: e.target.value,
      },
      [input]: e.target.value
    });
  };

  const handleChangeAutoCompete = (input: string, newValue: any) => {
    if (input === "instructionKey") {
      let instructiondata: InstructionKey | undefined = { code: "", name: "" };
      if (newValue) {
        instructiondata = instructionkeys.find(function (item: InstructionKey) {
          return item.code === newValue.code;
        });
      }
      if (instructiondata && newValue) {
        setDataToApprove({
          ...dataToApprove,
          vcExtendedInputs: {
            ...dataToApprove.vcExtendedInputs,
            [input]: instructiondata.code,
          },
        });
      } else {
        setDataToApprove({
          ...dataToApprove,
          vcExtendedInputs: {
            ...dataToApprove.vcExtendedInputs,
            [input]: "",
          },
        });
      }
    }
  };

  const getErrorState = (input: string) => {
    var errIndex = formErrors.findIndex(function (row) {
      return row.fieldName === input && row.errorMsg;
    });
    return errIndex !== -1 ? true : false;
  };

  const getApprovalPointCheckListIndex = () => {
    let tabIndex = "TL";
    if (ApprovalPointUtil.isTeamLeadAny(dataToApprove.approvalLevelId)) {
      tabIndex = "TL";
    } else if (ApprovalPointUtil.isCallOverVerificationAny(dataToApprove.approvalLevelId)) {
      tabIndex = "CV";
    } else if (ApprovalPointUtil.isSupportDocumentAny(dataToApprove.approvalLevelId)) {
      tabIndex = "SD";
    }
    return tabIndex;
  };

  const setFilteredCheckList = (index: string, checkList: Array<CheckListItem>, isRemoveCheck: boolean) => {
    if (dataToApprove) {
      let filteredCheckList: Array<CheckListItem> = [];
      if (index == "TL") {//Team lead
        filteredCheckList = checkList.filter(c => { return ApprovalPointUtil.isTeamLeadAny(c.approvalLevelId); })
          .sort((a, b) => a.sequenceNo = b.sequenceNo);
      } else if (index == "CV") {//caller verification
        filteredCheckList = checkList.filter(c => { return ApprovalPointUtil.isCallOverVerificationAny(c.approvalLevelId); })
          .sort((a, b) => a.sequenceNo = b.sequenceNo);
      } else if (index == "SD") {//support document
        filteredCheckList = checkList.filter(c => { return ApprovalPointUtil.isSupportDocumentAny(c.approvalLevelId); })
          .sort((a, b) => a.sequenceNo = b.sequenceNo);
      }
      filteredCheckList = filteredCheckList.map(c => { if (isRemoveCheck) { c.isChecked = false; } return c; });
      setCheckListItemsFiltered(filteredCheckList);

    } else {
      setCheckListItemsFiltered([]);
    }
  };

  const handleOpen = () => {
    if (dataToApprove &&
      ApprovalPointUtil.isOtherFinaceCreateorAmend(dataToApprove.vendorTypeCode, dataToApprove.approvalLevelId)
      || ApprovalPointUtil.isRmNonRMServiceApprover1(dataToApprove.vendorTypeCode, dataToApprove.approvalLevelId)
      || ApprovalPointUtil.isRmNonRMServiceLegatoTL(dataToApprove.vendorTypeCode, dataToApprove.approvalLevelId)) {//TODO -PBA load specifically
      prepareForRequest();
      Promise.allSettled([
        VendorAmendService.getInstructionKeyData(
          dataToApprove.companyCountryCode,
          function (instructionKeys: Array<InstructionKey>) {
            setInstructionkey(instructionKeys);
          },
          function (error: Error) {
            console.log(error);
            setInstructionkey([]);
          }
        ),
        VendorMasterData.getPurposeOfPaymentData(
          function (purposeOfpaymentData: Array<PaymentPurpose>) {
            setPaymentpurposes(purposeOfpaymentData);
          },
          function (error: Error) {
            console.log(error);
            setPaymentpurposes([]);
          }
        ),
        VendorMasterData.getSortKeyData(
          function (sortKeyData: Array<SortCode>) {
            setSortkeys(sortKeyData);
          },
          function () {
            setSortkeys([]);
          }
        ),
      ]).then((values) => {
        setApproverComment(dataToApprove.reasonForRejection);
        compeleteRequest(true);
      });
    }
    //create amend checklist
    if (dataToApprove && ApprovalPointUtil.isCheckListApplicable(dataToApprove.vendorTypeCode, dataToApprove.approvalLevelId)) {
      prepareForRequest();
      //set selected tab
      let tabIndex = getApprovalPointCheckListIndex();
      RequestService.GetCheckList(
        dataToApprove.requestId,
        function (data: Array<CheckListItem>) {
          setCheckListItems(data);
          //load initial tab data
          setFilteredCheckList(tabIndex, data, true);
          setTabSelectIndex(tabIndex);
          compeleteRequest(true);
        },
        function (error: Error) {
          console.log(error);
          setCheckListItems([]);
          setCheckListItemsFiltered([]);
          compeleteRequest(true);
        }
      );
    }
    if (dataToApprove &&
      ApprovalPointUtil.isSBUSCHeadOrGSSCLead(dataToApprove.approvalLevelId)) {
      const values: string[] = Object.values(DropdownOptions_TemporaryApproval_NoOfDays);
      let arr = new Array<TempApprovalNoOfDays>();
      values.map((item) => (
        arr.push({
          code: item,
          name: item
        })
      ));
      setNoOfDays(arr);
    }
  };

  const onCheckListItemClick = (event: any, item: CheckListItem) => {
    item.isChecked = !item.isChecked;
    const index = selectedCheckListItemIds.indexOf(item.id);
    let newList: number[] = [];
    if (index === -1) {
      newList = newList.concat(selectedCheckListItemIds, item.id);
    } else {
      newList = selectedCheckListItemIds.filter(i => i != item.id);
    }
    setSelectedCheckListItemIds(newList);
  };

  const handleCheckBoxChange = (event:any,input: string) => {
     dataToApprove.isTemporaryApproval = event.target.checked;
     setIsTempApproval(event.target.checked);
     if(event.target.checked==false)
     {
      dataToApprove.temporaryApprovalNoOfDays="";
     }
  setDataToApprove({
      ...dataToApprove,
      [input]: event.target.checked
    });
  };
  // const handleCheckListSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   if (event.target.checked) {
  //     const selectedIds = checkListItemsFiltered.map((n) => n.id);
  //     setSelectedCheckListItemIds(selectedIds);
  //     return;
  //   }
  //   setSelectedCheckListItemIds([]);
  // };

  // interface TabPanelProps {
  //   children?: React.ReactNode;
  //   dir?: string;
  //   index: any;
  //   value: any;
  // }

  // function TabPanel(props: TabPanelProps) {
  //   const { children, value, index, ...other } = props;

  //   return (
  //     <div
  //       role="tabpanel"
  //       hidden={value !== index}
  //       id={`full-width-tabpanel-${index}`}
  //       aria-labelledby={`full-width-tab-${index}`}
  //       {...other}
  //     >
  //       {value === index && (
  //         <div>{children}</div>
  //       )}
  //     </div>
  //   );
  // }

  return (
    <div className={classes.popUpOuter}>
      <Dialog
        open={open}
        onClose={handleClose}
        onExit={handleExit}
        onEnter={handleOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
      >
        <DialogTitle className={classes.popUpHeader} id="alert-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent className={classes.NoPopWrapper}>
          {/* <Grid hidden={!(dataToApprove && dataToApprove.requestComment)}  
          className={[classes.popdataRow ,classes.infoLabel].join(" ")} style={{ width: '90%' }}>
            <span className={classes.popUpLBL}>
              {translation.approve_comment_lbl}
            </span>
            <div className={classes.inputWrapper} style={{ marginBottom: 10 }}>
              <span style={{ fontSize: 12 }}>
                {dataToApprove?.requestComment}
              </span>
            </div>
          </Grid>           */}
          <Grid className={classes.popdataRow}>
              {translation.dashboard_approve_comment}
          </Grid>
          <Grid className={classes.popdataRow}>
            <TextField
              multiline
              rows={2}
              variant="outlined"
              value={approverComment}
              onChange={(e: any) => {setApproverComment(e.target.value); }}
              inputProps={{ maxLength: FieldsLengthConstants.RejectReason }}
            ></TextField>
          </Grid>
          <div style={{ fontWeight: "bold", margin: "10px 0 10px 0" }}>
            {message}
          </div>
          <Grid
            hidden={
              dataToApprove &&
              !ApprovalPointUtil.isUrgentAproveDisplay(dataToApprove.approvalLevelId)
            }
            className={classes.popdataRow}
          >
            <span className={classes.popUpLBL}>
              {translation.dashboard_approve_isuserurgent}
            </span>
            <Checkbox value={isUrgent}></Checkbox>
          </Grid>
          {/* {dataToApprove && ApprovalPointUtil.isOtherFinaceCreateorAmend(dataToApprove.vendorTypeCode, dataToApprove.approvalLevelId) && ( */}
          <Grid style={{ width: "100%", float: "left", }}>
            {dataToApprove && (ApprovalPointUtil.isOtherFinaceCreateorAmend(dataToApprove.vendorTypeCode, dataToApprove.approvalLevelId)) && (
              <Grid className={classes.popdataRow}>
                <span className={classes.popUpLBL}>
                  {translation.approve_purposecode_lbl}
                </span>
                <div className={classes.inputWrapper}>
                  <Select
                    variant="outlined"
                    value={
                      (dataToApprove &&
                        dataToApprove.vcExtendedInputs &&
                        dataToApprove.vcExtendedInputs.purposeCode) ||
                      ""
                    }
                    onChange={handleChange("purposeCode")}
                    error={getErrorState("purposeCode")}
                  >
                    <MenuItem value="">
                      <em>{translation.dropdown_empty_text}</em>
                    </MenuItem>
                    {paymentpurposes.map((obj) => (
                      <MenuItem key={obj.code} value={obj.code}>
                        {obj.name}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              </Grid>)
            }
            {dataToApprove && ApprovalPointUtil.isOtherFinaceCreateorAmend(dataToApprove.vendorTypeCode, dataToApprove.approvalLevelId) && (
              <Grid className={classes.popdataRow}>
                <span className={classes.popUpLBL}>
                  {translation.vendor_detail_bankdetails_inskey_lbl}
                  {dataToApprove.vcExtendedInputs.isIndividualVendor &&
                    <span style={{ float: "left", fontSize: "10px", width: "445px", textTransform: "lowercase" }}>
                      ({"Please change the instruction key through an amend request If required"})
                    </span>
                  }
                </span>
                <div className={classes.inputWrapper}>
                  <Autocomplete
                    disabled={dataToApprove.vcExtendedInputs.isIndividualVendor}
                    options={instructionkeys.map((obj) => obj)}
                    getOptionLabel={(option) => option.code}
                    onChange={(e, newValue) => {
                      e.preventDefault();
                      handleChangeAutoCompete("instructionKey", newValue);
                    }}
                    value={
                      instructionkeys.find(
                        (element) =>
                          element.code ===
                          dataToApprove.vcExtendedInputs.instructionKey
                      ) || null
                    }
                    renderOption={(option, props) => (
                      <li {...props}>
                        {option.name}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        margin="normal"
                        error={getErrorState("instructionKey")}
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                </div>
              </Grid>)
            }
            {dataToApprove && (ApprovalPointUtil.isRmNonRMServiceLegatoTL(dataToApprove.vendorTypeCode, dataToApprove.approvalLevelId)
              || ApprovalPointUtil.isOtherFinaceCreateorAmend(dataToApprove.vendorTypeCode, dataToApprove.approvalLevelId)) && (
                <Grid className={classes.popdataRow}>
                  <span className={classes.popUpLBL}>
                    {translation.approve_sortkey_lbl}
                  </span>
                  <div className={classes.inputWrapper}>
                    <Select
                      variant="outlined"
                      value={
                        (dataToApprove &&
                          dataToApprove.vcExtendedInputs &&
                          dataToApprove.vcExtendedInputs.sortKey) ||
                        ""
                      }
                      onChange={handleChange("sortKey")}
                      error={getErrorState("sortKey")}
                    >
                      <MenuItem value="">
                        <em>{translation.dropdown_empty_text}</em>
                      </MenuItem>
                      {sortkeys.map((obj) => (
                        <MenuItem key={obj.code} value={obj.code}>
                          {obj.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </Grid>)
            }
          </Grid>
          {/* )} */}
          {dataToApprove &&
            ApprovalPointUtil.isSAPCreateOrAmendOrExtend(
              dataToApprove.approvalLevelId
            ) && (
              <div>
                <Grid className={classes.popdataRow}>
                  <span className={classes.popUpLBL}>
                    {translation.approve_accounclk_lbl}
                  </span>
                  <div className={classes.inputWrapper_Req}>
                    <TextField
                      variant="outlined"
                      value={
                        (dataToApprove &&
                          dataToApprove.vcExtendedInputs &&
                          dataToApprove.vcExtendedInputs.accountingClark) ||
                        ""
                      }
                      onChange={handleChange("accountingClark")}
                      error={getErrorState("accountingClark")}
                      inputProps={{
                        maxLength: FieldsLengthConstants.AccountingClark,
                      }}
                    />
                  </div>
                </Grid>
                <Grid className={classes.popdataRow}>
                  <span className={classes.popUpLBL}>
                    {translation.approve_accounemail_lbl}
                  </span>
                  <div className={classes.inputWrapper_Req}>
                    <TextField
                      variant="outlined"
                      value={
                        (dataToApprove &&
                          dataToApprove.vcExtendedInputs &&
                          dataToApprove.vcExtendedInputs
                            .accountingClarkEmail) ||
                        ""
                      }
                      onChange={handleChange("accountingClarkEmail")}
                      error={getErrorState("accountingClarkEmail")}
                      inputProps={{
                        maxLength: FieldsLengthConstants.AccountingClarkEmail,
                      }}
                    />
                  </div>
                </Grid>
              </div>
            )}
          {/* ----------- CR start -----------------*/}
          {dataToApprove && ApprovalPointUtil.isSBUSCHeadOrGSSCLead(dataToApprove.approvalLevelId) && (
            <div>
              <Grid className={classes.popdataRow}>
                <span className={classes.popUpLBL} style={{ width: "auto", marginTop: "5px" }}>
                  {translation.dashboard_approve_isTemporaryApproval}
                </span>
                <Checkbox checked={isTempApproval} onChange={(e) => { setIsTempApproval(e.target.checked); }}
                onClick={(event) => handleCheckBoxChange(event,"isTemporaryApproval")}
                  style={{ padding: "0", marginBottom: "15px" }}/>
              </Grid>
              {isTempApproval && (
                <Grid className={classes.popdataRow}>
                  <span className={classes.popUpLBL}>
                    {translation.approve_noofdays_lbl}
                  </span>
                  <div className={classes.inputWrapper_Req}>
                    <Select
                      variant="outlined"
                      value={
                        (dataToApprove &&
                          dataToApprove.temporaryApprovalNoOfDays) ||
                        ""}
                      onChange={handleChange("temporaryApprovalNoOfDays")}
                      error={getErrorState("temporaryApprovalNoOfDays")}
                    >
                      <MenuItem value="">
                        <em>{translation.dropdown_empty_text}</em>
                      </MenuItem>
                      {noOfDays.map((obj) => (
                        <MenuItem key={obj.code} value={obj.code}>
                          {obj.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </Grid>)
              }
            </div>
          )}
          {/* CR end */}
          {tabSelectIndex && dataToApprove && ApprovalPointUtil.isCheckListApplicable(dataToApprove.vendorTypeCode, dataToApprove.approvalLevelId) &&
            (<Grid style={{ marginTop: "30px" }}>
              <Paper square elevation={3} style={{ paddingTop: "2px", float: "left" }}>
                <div style={{ fontWeight: "bold", margin: "10px 5px 10px 5px" }}>
                  Check list confirmation
                </div>
                <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12} className={classes.legendSection}>
                  <div className={classes.StatusDetails}>
                    <label><span className={classes.checkMandatoryState}></span>- Mandatory</label>
                  </div>
                  <div className={classes.StatusDetails}>
                    <label><span className={classes.checkOptionalState}></span>- Optional</label>
                  </div>
                </Grid>
                <Tabs
                  value={tabSelectIndex}
                  indicatorColor="primary"
                  textColor="primary"
                  onChange={handleTabChange}
                  aria-label="disabled tabs example"
                >
                  {dataToApprove
                    && ApprovalPointUtil.isTeamLeadAny(dataToApprove.approvalLevelId)
                    && (<Tab label="Team Lead" value="TL" />)
                  }
                  {dataToApprove
                    && (ApprovalPointUtil.isCallOverVerificationAny(dataToApprove.approvalLevelId) || ApprovalPointUtil.isTeamLeadAny(dataToApprove.approvalLevelId))
                    && (<Tab label="Callback" value="CV" />)
                  }
                  {dataToApprove
                    && (ApprovalPointUtil.isSupportDocumentAny(dataToApprove.approvalLevelId) || ApprovalPointUtil.isTeamLeadAny(dataToApprove.approvalLevelId))
                    && (<Tab label="Support Document" value="SD" />)
                  }
                </Tabs>
                <TableContainer component={Paper}>
                  <Table
                    //className={classes.table} 
                    size="small">
                    {/* <TableHead>
                      <TableRow>                    
                        <TableCell>Verification</TableCell>
                        <TableCell padding="checkbox">
                          <Checkbox
                            indeterminate={selectedCheckListItemIds.length > 0 && selectedCheckListItemIds.length < checkListItemsFiltered.length}
                            checked={checkListItemsFiltered.length > 0 && selectedCheckListItemIds.length === checkListItemsFiltered.length}
                            onChange={handleCheckListSelectAllClick}
                            inputProps={{ 'aria-label': 'select all desserts' }}
                          />
                        </TableCell>
                      </TableRow>
                    </TableHead> */}
                    <TableBody>
                      {checkListItemsFiltered.map((checkListItem, index) => {
                        const labelId = `enhanced-table-checkbox-${index}`;
                        return (
                          <TableRow key={checkListItem.id}>
                            <TableCell scope="row" className={checkListItem.priorityId == 1 ? classes.checkMandatoryState : classes.checkOptionalState} >
                              <div className={classes.checkList} dangerouslySetInnerHTML={{ __html: checkListItem.description }} />
                            </TableCell>
                            <TableCell padding="checkbox">
                              <Checkbox
                                disabled={tabSelectIndex != getApprovalPointCheckListIndex()}
                                checked={checkListItem.isChecked}
                                onClick={(event) => onCheckListItemClick(event, checkListItem)}
                                inputProps={{ 'aria-labelledby': labelId }}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <div style={{ margin: "10px 5px 10px 5px", color: "maroon", fontWeight: "bold" }}>
                  Declaration: I have reviewed and verified all relevant points and take full ownership of the responsibility for the outcomes
                </div>
              </Paper>

            </Grid>)
          }
        </DialogContent>
        <DialogActions>
          {dataToApprove && ApprovalPointUtil.isCallOverVerification(dataToApprove.approvalLevelId, RequestStatus.Pending) &&
            (<div>
              <span className={classes.popUpLBL} style={{ width: "auto", marginTop: "5px" }}>
                {translation.dashboard_approve_issendEmail}
              </span>
              <Checkbox value={isSendVendorConfirmation}
                onChange={(e) => { setIsSendVendorConfirmation(e.target.checked); }}
                style={{ padding: "0", marginBottom: "15px" }}></Checkbox>
            </div>)}

          <div style={{ margin: "20px ​10px 15px 0" }}>
            <div className={classes.greenBtnWrapper}>
              <Button onClick={handleConfirm} color="primary">
                <CheckCircleIcon></CheckCircleIcon>
                {btnOnetext}
              </Button>
            </div>
            <div className={classes.grayBtnWrapper}>
              <Button onClick={onApproveCancel} color="primary" autoFocus>
                {btnTwotext}
              </Button>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}
